class DrawerTypes {}
DrawerTypes.ACTIVITIES = "activities"
export default DrawerTypes
